import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: number = 0;

export const appealAttachedFilesSlice = createSlice({
 name: 'appealAttachedFiles',
 initialState,
 reducers: {
  appealAttachedFiles: (state, action: PayloadAction<number>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { appealAttachedFiles } = appealAttachedFilesSlice.actions;

export default appealAttachedFilesSlice.reducer;
